import { Component, inject, OnInit } from '@angular/core';
import { InternationalizationService } from '@app/core/services';

@Component({
  selector: 'jeopardy-main-menu-ev',
  templateUrl: './main-menu-ev.component.html',
  styleUrls: ['./main-menu-ev.component.scss'],
  standalone: true
})
export class MainMenuEvComponent implements OnInit {
  public i18n = inject(InternationalizationService);

  ngOnInit(): void {
  }

}
